













import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export default class Contact extends Vue {
  get contacts() {
    return this.$store.state.contact;
  }
}
